var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('admin-partial-navbar'),_vm._v(" "),_c('admin-partial-sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_vm._v(" "),_c('admin-partial-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }